import { useId, useState } from 'react';

export function ContentEditorTooltipButton({ label, tooltip = label, children, onKeyDown, ...props }) {
  const id = useId();
  const [hovered, setHovered] = useState(false);
  const [focused, setFocused] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const visible = !dismissed && (hovered || focused);
  return <span className="mts-editor-tooltip-control" onMouseEnter={() => { setHovered(true); setDismissed(false); }} onMouseLeave={() => setHovered(false)}>
    <button {...props} aria-label={label} aria-describedby={visible ? id : undefined} onFocus={() => { setFocused(true); setDismissed(false); }} onBlur={() => setFocused(false)} onKeyDown={event => { if (event.key === 'Escape') setDismissed(true); onKeyDown?.(event); }}>{children}</button>
    {visible ? <span id={id} role="tooltip" className="mts-editor-tooltip">{tooltip}</span> : null}
  </span>;
}
